import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Modal from 'jl-design-system/components/modal/Modal';
import Message from 'jl-design-system/components/message/Message';
import { PrimaryButton } from 'jl-design-system/elements/button/Button';
import { PrimaryLink, SecondaryLink } from 'jl-design-system/elements/link/Link';
// redux
import { connect } from 'react-redux';
import { removeBatchingFailureItems } from '../../redux/actions/edit-basket/editBasketActions';
// components
import OrderItem from '../order-item/OrderItem';
// styles
import styles from './batching-failure-modal.scss';
import appConstants from '../../constants/appConstants';

export class BatchingFailureModal extends PureComponent {

  static propTypes = {
    allItemsHaveBatchingFailure: PropTypes.bool,
    basketUrl: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    removeBatchingFailureItems: PropTypes.func,
    removeItemsFailed: PropTypes.bool,
    showModal: PropTypes.bool,
  };

  static defaultProps = {
    allItemsHaveBatchingFailure: false,
    basketUrl: '',
    items: undefined,
    removeBatchingFailureItems: window.defaultFunc,
    removeItemsFailed: false,
    showModal: false,
  };

  handleRemoveButtonClick = () => {
    const {
      items,
      removeBatchingFailureItems,
    } = this.props;

    removeBatchingFailureItems(items);
  };

  render() {
    const {
      allItemsHaveBatchingFailure,
      basketUrl,
      items,
      removeItemsFailed,
      showModal,
    } = this.props;

    if (!showModal) {
      return null;
    }

    const singleItem = items.length === 1;

    const removeItemButtonText = singleItem ?
      'Remove item and continue' : 'Remove items and continue';

    const topText = singleItem ?
      "We're sorry but the below item is unavailable to buy online." :
      "We're sorry but the below items are unavailable to buy online.";

    return (
      <Modal
        header="Something's gone wrong"
        hideCloseButton
        isOpen
        rootId={appConstants.ROOT}
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
      >
        <span data-test="batching-failure-top-text">{topText}</span>

        <div className={styles.itemContainer}>
          {items.map(item => <OrderItem {...item} key={item.id} displayImage hideSubtotals />)}
        </div>

        {
          (allItemsHaveBatchingFailure || removeItemsFailed) &&
          <p data-test="batching-failure-bottom-text">
            Please return to the basket. We apologise for any inconvenience caused.
          </p>
        }

        {
          (!allItemsHaveBatchingFailure && !removeItemsFailed) &&
          <div data-test="batching-failure-bottom-text">
            {
              singleItem &&
              <>
                <p>Please remove this item to continue with the rest of your order or you can return to the basket.</p>
                <p>We apologise for any inconvenience caused.</p>
              </>
            }

            {
              !singleItem &&
              <>
                <p>
                  Please remove these items to continue with the rest of your order
                  or you can return to the basket.
                </p>
                <p>We apologise for any inconvenience caused.</p>
              </>
            }
          </div>
        }

        {
          removeItemsFailed &&
          <Message
            title={`Sorry, we couldn't remove the item${singleItem ? '' : 's'}. Please return to basket.`}
            type="error"
          />
        }

        <div className={styles.buttonContainer}>
          {
            (allItemsHaveBatchingFailure || removeItemsFailed) &&
            <PrimaryLink
              data-action="handback"
              data-test="batching-failure-return-to-basket"
              to={basketUrl}
            >
              Return to basket
            </PrimaryLink>
          }

          {
            (!allItemsHaveBatchingFailure && !removeItemsFailed) &&
            <React.Fragment>
              <SecondaryLink
                data-action="handback"
                data-test="batching-failure-return-to-basket"
                to={basketUrl}
              >
                Return to basket
              </SecondaryLink>

              <PrimaryButton
                data-test="batching-failure-remove-item"
                onClick={this.handleRemoveButtonClick}
              >
                {removeItemButtonText}
              </PrimaryButton>
            </React.Fragment>
          }
        </div>
      </Modal>
    );
  }
}

export function mapStateToProps(state) {
  return {
    allItemsHaveBatchingFailure: state.user.allItemsHaveBatchingFailure,
    basketUrl: state.bff.basketUrl,
    items: state.user.batchingFailureItems,
    removeItemsFailed: state.user.showRemoveBatchingFailureItemError,
    showModal: state.user.showBatchingFailureModal,
  };
}

export function mapDispatchToProps() {
  return {
    removeBatchingFailureItems,
  };
}

export default connect(state => mapStateToProps(state), mapDispatchToProps())(BatchingFailureModal);
